import React, { useEffect } from 'react';
import { Container, Col, Row, Card, Dropdown } from 'react-bootstrap';
import { UseIcon } from '../../hooks/UseIcon';
import '../../../assets/css/Recruiter.css';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Spinner from '../../UI/Spinner/Spinner';
import { jobRequest } from '../../../store/jobOpportunities/async-actions';
import { useDispatch, useSelector } from 'react-redux';
import { ReqGet } from '../../../config/Requests';

function JobOpportunity(props) {
	const dispatch = useDispatch();

	const jobList = type => dispatch(jobRequest(type));

	const jl = params => {
		ReqGet('jobs', null, { params })
			.then(res => {
				if (!res.data.data) {
					// dispatch(jobListRequestFailed('Data not found'));
				} else {
					// dispatch(jobListRequestSuccess(res.data.data));
					return res.data.data;
				}
			})
			.catch(err => {
				dispatch(err.message);
			});
	};

	const jobListData = useSelector(state => state.data.jobList);
	const error = useSelector(state => state.data.errorMessage);
	const params = useSelector(state => state.data.searchParams);
	const initiated = useSelector(state => state.data.isInitiated);

	useEffect(() => {
		// props.jobList();
		jl();
	}, []);

	if (error) {
		return <p>{error}</p>;
	}
	const sortJobs = (type, e) => {
		e.preventDefault();
		if (type === 'none') {
			// props.jobList(null);
			jl(null);
		} else {
			// props.jobList({ orderBy: type });
			jl({ orderBy: type });
		}
	};

	const filterJobs = (type, e) => {
		e.preventDefault();
		if (type === 'none') {
			// props.jobList(null);
			jl(null);
		} else {
			// props.jobList({ job_type: type });
			jl({ job_type: type });
		}
	};
	return (
		<Container className='p-3 col-md-10 offset-1'>
			<Row style={{ width: '100%' }}>
				<Col md xs>
					<Dropdown onSelect={(value, e) => sortJobs(value, e)} id='sort'>
						<Dropdown.Toggle
							variant='outline-primary'
							className='pt-1 pb-1 pr-3 pl-3 mr-1'
							id='dropdown-basic'
						>
							<UseIcon
								icon='sorting'
								title='Sorting'
								simg='btn-img'
								stext='btn-text'
							/>
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<Dropdown.Item className='small dash-btn' eventKey='none'>
								None
							</Dropdown.Item>
							<Dropdown.Item className='small dash-btn' eventKey='recent'>
								Most recent
							</Dropdown.Item>
							<Dropdown.Item className='small dash-btn' eventKey='urgent'>
								Most urgent(Job Start Date)
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>

					<Dropdown onSelect={(value, e) => filterJobs(value, e)} id='filter'>
						<Dropdown.Toggle
							variant='outline-primary'
							className='pt-1 pb-1 pr-3 pl-3'
							id='dropdown-basic'
						>
							<UseIcon
								icon='filter'
								title='Filtering'
								simg='btn-img'
								stext='btn-text'
							/>
						</Dropdown.Toggle>
						<Dropdown.Menu>
							<Dropdown.Item className='small dash-btn' eventKey='fullTime'>
								Full Time
							</Dropdown.Item>
							<Dropdown.Item className='small dash-btn' eventKey='halfTime'>
								Half time
							</Dropdown.Item>
							<Dropdown.Item className='small dash-btn' eventKey='both'>
								Both
							</Dropdown.Item>
							<Dropdown.Item className='small dash-btn' eventKey='none'>
								None
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</Col>
			</Row>

			<Row style={{ width: '100%' }}>
				{initiated === true ? (
					<Spinner />
				) : (
					<Col className='p-3'>
						{jobListData.length !== 0 ? (
							jobListData.map((data, i) => {
								const startDate = moment(data.start_date).format('MM-DD-YYYY');
								const endDate = moment(data.end_date).format('MM-DD-YYYY');
								var text = data?.description;
								var count = 25;
								var result =
									text?.slice(0, count) + (text?.length > count ? '...' : '');
								return (
									<Card key={data.id} className='mt-3 mb-2 shadow-sm'>
										<Card.Body>
											<Card.Title className='text-primary small p-1 font-weight-bolder'>
												<Link to={`/job/${data.id}`}>{data.title}</Link>
											</Card.Title>
											<Card.Text className='text-job-normal'>
												Client ID #: {data.client.id}
											</Card.Text>
											<Card.Text className='text-job-normal'>
												Number of Applicants: {data.members_count}
											</Card.Text>
											<Card.Text className='text-job-regular'>
												Start Date: &nbsp;{startDate}
											</Card.Text>
											<Card.Text className='text-job-regular'>
												End Date: &nbsp;{endDate}
											</Card.Text>
											<Card.Text className='text-job-orange'>
												General: &nbsp;
												<span style={{ color: 'black' }}>{result}</span>
											</Card.Text>
											<Card.Text className='text-job-orange'>
												Location:{' '}
												<span style={{ color: 'black' }}>
													{data.state.name}, {data.city.name}{' '}
												</span>
											</Card.Text>
										</Card.Body>
									</Card>
								);
							})
						) : (
							<h2> No Job Opportunity available at this time </h2>
						)}
					</Col>
				)}
			</Row>
		</Container>
	);
}

export default JobOpportunity;
